import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// O app usa HashRouter, mas links enviados para fora (ex.: /cotacao/:token,
// /redefinir-senha/:token) chegam como caminho normal. Convertemos para
// /#/caminho antes de montar, para o roteador encontrar a rota certa.
const { pathname, search, hash } = window.location;
if (pathname !== '/' && pathname !== '/index.html' && !hash) {
  window.history.replaceState(null, '', `/#${pathname}${search}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
